import { useAppStore } from '@40seas/frontend/dashboard/contexts';
import { Box, Theme, Typography, useMediaQuery } from '@mui/material';

export const TestModeAppBar = (props) => {
    const { isTestMode } = useAppStore();
    const isXSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));

    if (!isTestMode) return null;

    return (
        <Box
            sx={{
                backgroundColor: 'test.main',
                display: 'flex',
                alignItems: 'center',
                padding: '5px 20px',
            }}
        >
            {!isXSmall && <Typography sx={{ color: 'white', textAlign: 'center', fontSize: '1.125rem' }}>Test mode</Typography>}
            <Typography sx={{ color: 'white', textAlign: 'center', flexGrow: 1 }} variant="body2">
                You are using test mode. Real money won't be transferred.
            </Typography>
        </Box>
    );
};
